export const services = [
  {
    icon: "/images/fullsatckk.jpg",
    title: "Full Stack Web Development",
    description:
      "Building scalable web applications using React, Next.js, Node.js, and modern backend architectures with REST APIs and databases.",
  },
  {
    icon: "/images/frontend.png",
    title: "Mobile App Development",
    description:
      "Developing cross-platform mobile applications using React Native with a focus on performance, smooth UX, and real-world solutions.",
  },
  {
    icon: "/images/backend.jpg",
    title: "Backend & System Integration",
    description:
      "Designing backend services, integrating APIs, and connecting applications with databases like MongoDB, PostgreSQL, and MySQL.",
  },
  {
    icon: "/images/cloud.jpg",
    title: "Cloud Deployment & Hosting",
    description:
      "Deploying applications on cloud platforms like Vercel and Render for reliable, scalable, and secure hosting.",
  },
  {
    icon: "/images/database.jpg",
    title: "Database Management",
    description:
      "Enhancing productivity through efficient database management using Prisma, PostgreSQL, MongoDB, MySQL, and modern database tools for optimized workflows and seamless integration",
  },
  {
    icon: "/images/api.jpg",
    title: "Automation & API Development",
    description:
      "Creating automated workflows and robust REST APIs to streamline processes and integrate complex systems seamlessly.",
  },
];

export const skills = [
  // {
  //   name: "JavaScript",
  //   logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  //   href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  // },
  {
    name: "TypeScript",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    href: "https://www.typescriptlang.org/",
  },
  // {
  //   name: "React",
  //   logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  //   href: "https://react.dev",
  // },
  {
    name: "Next.js",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
    href: "https://nextjs.org",
  },
  {
    name: "Node.js",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    href: "https://nodejs.org",
  },
  {
    name: "MongoDB",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    href: "https://mongodb.com",
  },
  {
    name: "PostgreSQL",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
    href: "https://postgresql.org",
  },
  {
    name: "Prisma",
    logo: "https://cdn.worldvectorlogo.com/logos/prisma-2.svg",
    href: "https://www.prisma.io",
  },
  // {
  //   name: "Git",
  //   logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  //   href: "https://git-scm.com",
  // },
];
export const portfolioProjects = [
  {
    category: "Web Application",
    title: "Inventory Management System (Next.js)",
    image: "/inventory.png",
    link:"https://inventory-management-system-next-js.vercel.app/",
    github:"https://github.com/fiacredev/inventory-management-system-next-js"
  },
  {
    category: "Web Application",
    title: "Airflow ventilation system (Next.js)",
    image: "/norry.png",
    link:"https://airflowpro-norry-duxy.vercel.app/",
    github:"https://github.com/fiacredev/airflowpro-norry-duxy"
  },
  {
    category: "Desktop Application (Partner Collaboration)",
    title: "Bridging Local And Remote Repositories (Electron)",
    image: "/rempoo.png",
    link:"https://rempoapp.vercel.app/",
    github:"https://github.com/fiacredev/REMPO"
  },
  {
    category: "Web Application (storage is down)",
    title: "E-Commerce Coffee Shop (Pocketbase)",
    image: "/ritha.png",
    link:"https://github.com/fiacredev/coffee-shop-e-commerce",
    github:"https://github.com/fiacredev/coffee-shop-e-commerce"
  },
  {
    category: "API Ecosystem Dynamics (storage is down)",
    title: "Academic Backend System with Role Based Authorization (Express.js & MongoDB)",
    image: "/images/role.png",
    link:"https://github.com/fiacredev/role-based--access-control-system",
    github:"https://github.com/fiacredev/role-based--access-control-system"
  },
  {
    category: "Mobile Application",
    title: "Employment and career opportunities (React Native)",
    image: "/images/joblanding.jpg",
    link:"https://portifolio-rosy-three-76.vercel.app/landing",
    github:"https://github.com/fiacredev/job-landing-react-native"
  },
    {
    category: "Mobile Application",
    title: "Food ordering system for campus (React Native)",
    image: "/images/foody.png",
    link:"https://portifolio-rosy-three-76.vercel.app/landing",
    github:"https://github.com/fiacredev/foody-react-native"
  },
    {
    category: "Mobile Application",
    title: "Waypoint - Driver & Passenger Sync Platform (React Native)",
    image: "/images/curb.jpg",
    link:"https://portifolio-rosy-three-76.vercel.app/landing",
    github:"https://github.com/fiacredev/curb-side-react-native"
  },
  
];

export const blogArticles = [
  {
    category: "Hackathon",
    title: "My Experience at Hack With Me Rwanda",
    description:
      "Participating in a 2-day hackathon with 100+ students helped me improve my collaboration, coding speed, and real-world problem solving.",
    image: "/images/hack.jpg",
    date: "December 2023",
  },
  {
    category: "Hackathon",
    title: "Building Projects at HackNoel",
    description:
      "HackNoel brought together high school developers to build web apps, mobile apps, and chatbots while learning from each other.",
  },
  {
    category: "Development",
    title: "How I Started Coding in 2022",
    description:
      "My journey into software development started with curiosity about programming and quickly turned into building real applications.",
  },
  {
    category: "Mobile Development",
    title: "Why I Love Building Apps with React Native",
    description:
      "React Native allows me to build powerful mobile apps while sharing logic with web technologies like JavaScript and TypeScript.",
  },
];

export const faqItems = [
  {
    id: "1",
    question: "What technologies do you specialize in?",
    answer:
      "I specialize in JavaScript, TypeScript, React, Next.js, Node.js, and React Native. I also work with databases like MongoDB, PostgreSQL, and MySQL.",
  },
  {
    id: "2",
    question: "Do you build both web and mobile applications?",
    answer:
      "Yes. I develop full stack web applications using Next.js and backend technologies, and mobile apps using React Native.",
  },
  {
    id: "3",
    question: "What kind of projects have you built?",
    answer:
      "I have built several projects including a job search mobile app, a campus food ordering app, an inventory management system, and an e-commerce platform.",
  },
  {
    id: "4",
    question: "Have you participated in hackathons?",
    answer:
      "Yes. I participated in Hack With Me Rwanda, Africa's Talking and HackNoel where I collaborated with other developers to build real projects during intensive hackathon sessions.",
  },
  {
    id: "5",
    question: "When did you start coding?",
    answer:
      "I started coding in 2022 and have been continuously building projects and improving my development skills since then.",
  },
  {
    id: "6",
    question: "Do you have any teaching or mentoring experience?",
    answer:
      "Yes. I worked as a coding trainer at Convenient General Business where I mentored students in programming fundamentals, guided them through practical projects, and helped them build problem-solving skills.",
  },
  {
    id: "7",
    question: "What is your educational background?",
    answer:
      "I am currently studying at African Leadership University, where I am developing strong skills in software engineering, leadership, and real-world problem solving.",
  },
  {
    id: "8",
    question: "How many years of experience do you have in coding?",
    answer:
      "I have over 4 years of experience in coding, during which I have worked on diverse projects, trained others, and continuously improved my technical and professional skills.",
  },
  {
    id: "9",
    question: "What makes you stand out as a developer?",
    answer:
      "My combination of hands-on development experience, teaching background, and continuous learning mindset allows me to not only build scalable applications but also communicate complex ideas clearly and work effectively in teams.",
  },
  {
    id: "10",
    question: "Are you open to collaboration or freelance work?",
    answer:
      "Yes. I am open to collaborating on innovative projects, freelance opportunities, and contributing to teams where I can add value and continue growing as a developer.",
  },
];

export const workHistory = [
  {
    period: "2022",
    title: "Started Coding Journey",
    role: "Self-Taught Developer",
    description:
      "Started learning programming and web development, focusing on JavaScript and building small projects to understand core development concepts.",
  },
  {
    period: "2023",
    title: "Hackathon Experience",
    role: "Hackathon Participant",
    description:
      "Participated in Hack With Me Rwanda, Africa's talking and HackNoel hackathons, collaborating with students to build applications and improve teamwork and coding speed.",
  },
  {
    period: "2024",
    title: "Full Stack Developer",
    role: "Project Builder",
    description:
      "Built multiple projects including React Native apps, Next.js systems, backend APIs, and real-world web applications.",
  },
  {
    period: "Now",
    title: "College Developer",
    role: "Full Stack & Mobile Developer",
    description:
      "Currently studying in college while continuing to build scalable web and mobile applications using modern technologies.",
  },
];